export const tableStyles = {
  'headerTableStyles': {
    headerTableTdClasses: {
      'primaryGreenBg': {
        'primary-green-bg': true
      },
      'darkGreenBg': {
        'dark-green-bg': true
      }
    },
    headerTable: {
      'border-collapse': 'collapse',
      'font-size': '1.2rem',
      'font-weight': 'normal',
      'text-align': 'left'
    },
    tableStyle: {
      'font-size': '1.5rem',
      'border-collapse': 'collapse',
      'width': '100%',
      'margin-left': '1.5rem'
    },
    thStyle: {
      'font-weight': 'normal',
      'padding': '0.5rem 1rem',
      'color': 'white',
      'border-color': 'white'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '0.5rem 1rem',
      'background-color': 'white',
      'word-wrap': 'break-word'
    },
    trStyle: {
      'border': '1px solid #cecece'
    }
  },
  summaryTableStyles: {
    tableStyle: {
      'font-size': '1.2rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '0.5rem 1rem',
      'background-color': 'rgb(246,246,230)'
    },
    trStyle: {
      'border': '1px solid #cecece'
    }
  },
  detailsTableStyles: {
    tableStyle: {
      'font-size': '1.2rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '0.5rem 1rem',
      'background-color': 'white'
    },
    trStyle: {
      'border': '1px solid #cecece'
    },
    editBoxWidthFull: {
      'display': 'inline-block',
      'width': '95%',
      'height': '32px',
      'padding-left': '1rem',
      'padding-right': '1rem'
    },
    actualStyle: {
      'color': 'black',
      'padding': '0.5rem 1rem',
      'background-color': 'white'
    },
    estimatedStyle: {
      'color': '#00AF41',
      'padding': '0.5rem 1rem',
      'background-color': 'white'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/offers-component/tableStyles.js